<template>
    <div class="user_info_store_popup">
        <div class="user_req_form_modal" v-if="meetingStatusData">
            <div class="user_info_store_popup_center">
                <div class="user_req_form_modal_body">
                    <div class="user_info_store_popup_logo">
                        <img src="@/assets/images/logo.png" class="img-fluid" alt="" width="300">
                        <h2 class="pub_meet_heading">Public Meeting / Webinar</h2>
                    </div>
                    <template v-if="meetingStatusFlag">
                        <template v-if="maxCapacityState">
                            <div class="public_meeting_status_wrp max_capcity_box">
                                <div class="public_meeting_status_blurb">
                                    <p>This meeting has hit maximum capacity.</p>
                                    <p>Please log in/sign up at <router-link to="/">www.lymphomap.ai</router-link> to
                                        check out exclusive content for our
                                        members.
                                    </p>
                                    <p>If you have any questions, you may contact us at <a
                                            href="mailto:info@lymphomap.ai">info@lymphomap.ai</a>.</p>
                                    <p class="pt-3 mb-0">
                                        <router-link to="/" class="btn btn-primary">Exit</router-link>
                                    </p>
                                </div>
                            </div>
                        </template>
                        <div class="user_info_store_popup_modal" v-else>
                            <div class="user_info_store_popup_header">
                                <h4>Info</h4>
                            </div>
                            <div class="user_info_store_popup_body">
                                <form @submit.prevent="sendUserInfoSubmitMethod">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>First Name</label>
                                                <input type="text" class="form-control" v-validate="'required'"
                                                    v-model="first_name" name="first_name"
                                                    v-bind:class="{ 'is-invalid': errors.has('first_name') }"
                                                    data-vv-as="first name">
                                                <small class="invalid-feedback" v-if="errors.has('first_name')">{{
                                                    errors.first('first_name')
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Last Name</label>
                                                <input type="text" class="form-control" v-validate="'required'"
                                                    v-model="last_name" name="last_name"
                                                    v-bind:class="{ 'is-invalid': errors.has('last_name') }"
                                                    data-vv-as="last name">
                                                <small class="invalid-feedback" v-if="errors.has('last_name')">{{
                                                    errors.first('last_name')
                                                    }}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="email" class="form-control" v-validate="'required'"
                                                    v-model="email" name="email"
                                                    v-bind:class="{ 'is-invalid': errors.has('email') }"
                                                    data-vv-as="email">
                                                <small class="invalid-feedback" v-if="errors.has('email')">{{
                                                    errors.first('email') }}</small>
                                            </div>
                                            <div class="form-group">
                                                <label class="is_public_blurb">If you exit this meeting, you may return at any time.
                                                    However, for unique identification and privacy purposes, you must
                                                    rejoin with a different
                                                    email
                                                    address.</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 text-left">
                                            <button type="submit" class="btn btn-danger"
                                                :disabled="submitted">Join</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </template>
                    <div class="public_meeting_status_wrp" v-else>
                        <div class="public_meeting_status_blurb">
                            <p>This meeting has ended. You may contact us at <a
                                    href="mailto:info@lymphomap.ai">info@lymphomap.ai</a>.
                            </p>
                            <p>Thank you for choosing Lymphomap.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="user_req_form_modal" v-if="idInvalidStatus">
            <div class="user_info_store_popup_center">
                <div class="user_req_form_modal_body">
                    <div class="user_info_store_popup_logo">
                        <img src="@/assets/images/logo.png" class="img-fluid" alt="" width="300">
                    </div>
                    <div class="public_meeting_status_wrp">
                        <div class="public_meeting_status_blurb">
                            <p>This meeting has ended. You may contact us at <a
                                    href="mailto:info@lymphomap.ai">info@lymphomap.ai</a>.
                            </p>
                            <p>Thank you for choosing Lymphomap.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import { bus } from "@/main";

const MAX_MEETING_CAPACITY = 40;

export default {
    name: "user-info-for-conference",

    props: {
        meetingID: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            submitted: false,
            first_name: "",
            last_name: "",
            email: "",
            clientIP: "",
            meetingStatusData: null,
            meetingStatusFlag: false,
            idInvalidStatus: false,
            maxCapacityState: false
        };
    },

    computed: {
    },

    async mounted() {
        await this.getSystemIpMethod();

        if (!this.$route.hash) return;

        try {
            const res = await this.$store.dispatch("getPubMeetingStatusAction", {
                id: this.$route.hash.substring(1)
            });

            this.meetingStatusData = res.data.data;
            this.meetingStatusFlag = this.meetingStatusData.is_pubilc_meeting;
            this.maxCapacityState =
                this.meetingStatusData.count >= MAX_MEETING_CAPACITY;
        } catch (e) {
            this.idInvalidStatus = true;
        }
    },

    methods: {
        async getSystemIpMethod() {
            try {
                const response = await fetch("https://ipapi.co/json/");
                const data = await response.json();
                this.clientIP = data.ip || "";
            } catch (error) {
                console.error("Request failed", error);
            }
        },

        async sendUserInfoSubmitMethod() {
            const valid = await this.$validator.validateAll();
            if (!valid) return;

            this.submitted = true;

            try {
                const payload = {
                    name: `${this.first_name} ${this.last_name}`.trim(),
                    email: this.email,
                    ip_add: this.clientIP,
                    meeting_id: this.meetingID
                };

                bus.$emit("meetingStartAlert", payload);

                this.closeStoreInfoPopup();
            } catch (err) {
            } finally {
                this.submitted = false;
            }
        },

        closeStoreInfoPopup() {
            document.body.classList.remove("body_right_scroll_remove");
            bus.$emit("userInfoStoreBus", false);
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('../../../assets/fonts/acetone/style.css');

.user_info_store_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1002;
    background: rgba(0, 0, 0, 0.75);
    display: table;
    width: 100%;
    height: 100%;
    color: #ffffff;
    // padding:15px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .user_req_form_modal {
        height: 100dvh;
        overflow-y: auto;
        padding: 15px;
    }

    .user_info_store_popup_center {
        display: table;
        width: 100%;
        height: 100%;
    }

    .user_req_form_modal_body {
        display: table-cell;
        vertical-align: middle;
    }

    .user_info_store_popup_modal {
        background: #000;
        max-width: 520px;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .user_info_store_popup_close {
        position: absolute;
        top: 15px;
        right: 10px;
        line-height: 1;

        .fa {
            font-size: 20px;
            color: red;
            cursor: pointer;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: all ease 0.5s;
            transition: all ease 0.5s;
        }
    }

    .user_info_store_popup_header {
        padding: 15px;
        position: relative;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        h4 {
            font-size: 24px;
            letter-spacing: 0;
            margin-bottom: 0;
        }
    }

    .user_info_store_popup_body {
        padding: 15px;

        label {
            font-size: 16px;
            margin-bottom: 4px;

            &.is_public_blurb {
                font-size: 16px;
                margin: 0;
                line-height: 1.2;
                color: #ffd400;
                text-align: justify;
            }
        }

        .form-control {
            height: auto;
            padding: 7px 15px;
            background: rgba(255, 255, 255, 0.1);
            border-color: transparent;
            font-size: 16px;
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
            transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
        }

        .mx-datepicker {
            width: 100%;
        }

        .invalid-feedback {
            font-size: 14px;
            line-height: 1;
            display: block;
        }
    }

    .btn-danger {
        width: 90px;
        font-size: 18px;
        padding: 10px 0px;
        line-height: 1;
        background: #ff3a30;
        border: none;
        outline: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;

        &:hover {
            background: #87cefa;
            color: #000000;
        }
    }

    .vue-tel-input {
        border-radius: 3px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        text-align: left;
    }

    .vue-tel-input .dropdown {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-line-pack: center;
        align-content: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        position: relative;
        padding: 7px;
        cursor: pointer;
        outline: 0;
        box-shadow: none;
        background: #282828;
        border-radius: 3px 0px 0px 3px;
    }

    .vue-tel-input .form-control {
        border-radius: 0 3px 3px 0;
    }

    .vue-tel-input ul {
        z-index: 1;
        padding: 0;
        margin: 0;
        text-align: left;
        list-style: none;
        max-height: 260px;
        overflow-y: scroll;
        position: absolute;
        top: 36px;
        left: 0px;
        padding-top: 5px;
        background: rgba(40, 40, 40, 0.95);
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .vue-tel-input .form-control {
        outline: none;
        box-shadow: none;
    }

    .iti-flag {
        margin-right: 5px;
        margin-left: 5px;
    }

    .vue-tel-input .selection {
        font-size: .8em;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .vue-tel-input .dropdown-arrow {
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
        display: inline-block;
        color: #666;
    }

    .vue-tel-input .dropdown-item {
        cursor: pointer;
        padding: 4px 15px;
        font-size: 18px;
        color: #ffc107;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        strong {
            font-weight: normal;
        }

        &:hover {
            background: #2b76ff !important;
            color: #fff;
        }
    }

    .vue-tel-input .dropdown-item .iti-flag {
        display: inline-block;
        margin-right: 5px;
    }

    .vue-tel-input .dropdown.open,
    .vue-tel-input .dropdown:hover {
        background-color: #535353;
    }

    .custom_mobile_number .form-control {
        box-shadow: none;
        outline: none;
    }

    .conference_join_txt {
        display: flex;
        align-items: start;

        span {
            margin-left: 12px;
            text-align: justify;
        }

        input[type="checkbox"] {
            margin-top: 5px;
        }
    }

    .user_info_store_popup_logo {
        text-align: center;
        margin-bottom: 40px;
    }

    .public_meeting_status_blurb {
        text-align: center;

        p {
            font-size: 24px;

            a {
                color: #87cefa;
                text-decoration: none;

                &:hover {
                    color: #ffc107;
                }
            }
        }
    }

    .max_capcity_box {
        .btn-primary {
            font-family: 'ACETONE';
            background: rgba(0, 0, 0, 0.6);
            border: 2px solid #ffe400 !important;
            color: #ffe400 !important;
            text-transform: uppercase;
            font-size: 28px;
            padding: 5px 8px;
            line-height: 1;
            height: auto;
            min-width: 110px;
            display: inline-block;
            border-radius: 6px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            text-decoration: none !important;

            &:hover {
                background: #ffe400 !important;
                color: #000000 !important;
            }
        }
    }

    .pub_meet_heading {
        font-size: 26px;
        margin-top: 25px;
        font-family: BeonMedium, sans-serif;
        font-weight: bold;
        letter-spacing: 0.5;
    }
}

@media only screen and (max-width:767px) {
    .user_info_store_popup {
        .pub_meet_heading {
            font-size: 22px;
            margin-top: 18px;
        }

        .user_info_store_popup_logo {
            margin-bottom: 30px;
        }
    }
}
</style>